// File upload constraints
export const ALLOWED_FILE_TYPES = [
	"image/jpeg",
	"image/png",
	"application/pdf",
] as const;

export const ALLOWED_FILE_EXTENSIONS = ".jpg,.jpeg,.png,.pdf";

export const FILE_TYPE_ERROR_MESSAGE =
	"Only JPG, PNG, and PDF files are allowed";

// Textarea constraints
export const TEXTAREA_LINE_HEIGHT = 24;
export const TEXTAREA_SINGLE_LINE_HEIGHT = 50;
export const TEXTAREA_MAX_LINES = 4;
export const TEXTAREA_MAX_HEIGHT =
	TEXTAREA_LINE_HEIGHT * TEXTAREA_MAX_LINES + 6; // 102px

// Recording
export const AUDIO_MIME_TYPE = "audio/webm";
export const AUDIO_FILE_NAME = "audio.webm";

// Analytics event names are no longer centralized here — each section routes
// through its own `logX(<bare name>)` wrapper in src/lib/analytics.ts
// (AI chat → logChat, provider/expert → logCommunication).

// Question category types
export const QuestionCategory = {
	Legal: "legal",
	ComparisonsAndDilemmas: "comparisons-dilemmas",
	LifestylePreparation: "lifestyle-preparation",
	GettingStarted: "getting-started",
	Medical: "medical",
	EmotionalMentalHealth: "emotional-mental-health",
	FinancialPlanning: "financial-planning",
	DonorSurrogacyMatching: "donor-surrogacy-matching",
	Providers: "providers",
	TimelineReadiness: "timeline-readiness",
} as const;

// Category color mapping
export const CATEGORY_COLORS: Record<string, string> = {
	[QuestionCategory.Legal]: "#f03050", // Red/Pink - Legal matters
	[QuestionCategory.ComparisonsAndDilemmas]: "#ff9500", // Orange - Decision making
	[QuestionCategory.LifestylePreparation]: "#399c08", // Green - Lifestyle & wellness
	[QuestionCategory.GettingStarted]: "#3265f0", // Blue - Getting started
	[QuestionCategory.Medical]: "#7536ff", // Purple - Medical/treatment
	[QuestionCategory.EmotionalMentalHealth]: "#f03050", // Red/Pink - Emotional support
	[QuestionCategory.FinancialPlanning]: "#ff9500", // Orange - Financial
	[QuestionCategory.DonorSurrogacyMatching]: "#00c7be", // Teal - Donor/surrogacy
	[QuestionCategory.Providers]: "#7536ff", // Purple - Providers
	[QuestionCategory.TimelineReadiness]: "#3265f0", // Blue - Timeline planning
	default: "#3265f0", // Blue - Default fallback
} as const;
